/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Cta_PrimaryInputs */

const en_mk_hero_cta_primary = /** @type {(inputs: Mk_Hero_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free`)
};

const id_mk_hero_cta_primary = /** @type {(inputs: Mk_Hero_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai gratis`)
};

/**
* | output |
* | --- |
* | "Start free" |
*
* @param {Mk_Hero_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_cta_primary = /** @type {((inputs?: Mk_Hero_Cta_PrimaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Cta_PrimaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_cta_primary(inputs)
	return en_mk_hero_cta_primary(inputs)
});